import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RMA_DEFAULT_HTTP_OPTIONS } from '@rma/dashboard/generic/util/environment';
import { ProfileType, VerticalType } from '@rma/generic/domain/types';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { ProfileSummary } from './domain/profile-summary.model';

/**
 * This is the endpoint public uses to get basic profile information
 */
@Injectable({
  providedIn: 'root',
})
export class ProfileDetailsApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public getProfileDetails(verticalType: VerticalType, profileType: ProfileType, profileCode: string) {
    const url = this.rmaApiUrl(`/v1/Profiles/${verticalType}/${profileType}/${profileCode}/Details`);
    return this.httpClient.get<ProfileSummary>(url, RMA_DEFAULT_HTTP_OPTIONS);
  }
}
